module.exports = "/_next/static/images/ConnectToLeadingData@2x-8372b2ec1fba3687404ad9457465acb1.webp";